/* ============================================================
   OBEE EXTRACTS — Technik-Bereich, gepinnt mit vier Schritten
   ============================================================ */
(function () {
  'use strict';
  var root = document.getElementById('tech'); if (!root) return;
  var pin   = root.querySelector('.pin');
  var fill  = root.querySelector('.techbar i');
  var steps = root.querySelectorAll('.tech-step');
  var btns  = root.querySelectorAll('.tech-nav button');
  var imgs  = root.querySelectorAll('.tech-dev img');
  var N = steps.length;
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cur = -1, FRAMES = 48;

  function show(i) {
    if (i === cur) return;
    cur = i;
    steps.forEach(function (s, k) { s.classList.toggle('on', k === i); });
    btns.forEach(function (b, k) { b.classList.toggle('on', k === i); });
    // Gerät: je Schritt ein anderer Winkel aus der Rotationssequenz
    var frame = 1 + Math.round(i * (FRAMES - 1) / Math.max(1, N - 1));
    imgs.forEach(function (im) { im.classList.toggle('on', +im.dataset.i === frame); });
    var tilt = [14, -9, 8, -13][i] || 0;
    imgs.forEach(function (im) { im.style.setProperty('--tilt', tilt + 'deg'); });
  }

  function onScroll() {
    var r = root.getBoundingClientRect();
    var total = root.offsetHeight - window.innerHeight;
    var p = Math.min(1, Math.max(0, -r.top / Math.max(1, total)));
    if (fill) fill.style.width = (p * 100).toFixed(2) + '%';
    show(Math.min(N - 1, Math.floor(p * N * 0.999)));
  }

  btns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      var total = root.offsetHeight - window.innerHeight;
      var y = root.offsetTop + total * ((i + 0.5) / N);
      window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
    });
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  show(0); onScroll();
})();
